module.exports = __webpack_public_path__ + "img/top.07a3f65f.jpg";